import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// React Router v6 hooks needed for Sentry’s routing integration
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom'

// Redirect TFLite/MediaPipe WASM stderr messages (prefixed "INFO:") from console.error to console.info
const _originalConsoleError = console.error.bind(console)
console.error = (...args: unknown[]) => {
  if (typeof args[0] === 'string' && args[0].startsWith('INFO:')) {
    console.info(...args)
    return
  }
  _originalConsoleError(...args)
}

// 1) Initialize Sentry with the v6 router integration
Sentry.init({
  dsn: 'https://c8ccbcd16b6d051ec59c697c8e864364@o4509597828317184.ingest.de.sentry.io/4509597921574992',
  integrations: [
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      // supply React’s useEffect and the RR hooks
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  // enable 100% sampling for traces in dev; tune down in prod
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
  enableLogs: true,
})

// 2) Mount React tree, wrapped in an ErrorBoundary
const container = document.getElementById('root')
if (!container) throw new Error('Could not find #root container')

const root = createRoot(container)
root.render(
  <Sentry.ErrorBoundary fallback={<div>Oops, something broke.</div>}>
    <App />
  </Sentry.ErrorBoundary>
)
